module.exports = __webpack_public_path__ + "img/utama.1c454da3.svg";